export default __webpack_public_path__ + "img/logo.8da5f11e.svg";